import { createContext, useContext } from 'react';
import { DEFAULT_LOCALE, Locale, LocaleMeta, SUPPORTED_LOCALES } from './types';

export interface LocaleContextValue extends LocaleMeta {
  setLocale: (locale: Locale) => void;
  toggleLocale: () => void;
}

export const LocaleContext = createContext<LocaleContextValue>({
  locale: DEFAULT_LOCALE,
  direction: 'ltr',
  label: 'English',
  setLocale: () => {},
  toggleLocale: () => {},
});

export function useLocale(): LocaleContextValue {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
}

export function findLocaleMeta(locale: Locale): LocaleMeta {
  return SUPPORTED_LOCALES.find((meta) => meta.locale === locale) ?? SUPPORTED_LOCALES[0];
}
